export enum JobStatus {
  PENDING = 'pending',
  IN_PROGRESS = 'in_progress',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum PaymentStatus {
  UNPAID = 'unpaid',
  PARTIAL = 'partial',
  PAID = 'paid'
}

export enum UserRole {
  ADMIN = 'admin',
  FREELANCER = 'freelancer',
  CLIENT = 'client'
}

export type CurrencyCode = 'USD' | 'KES' | 'EUR' | 'GBP';

export type EmailFolder = 'inbox' | 'sent' | 'drafts' | 'trash' | 'starred' | 'spam';

export type TemplateId =
  | 'system' // Internal use only
  | 'modern'
  | 'classic'
  | 'bold'
  | 'minimalist'
  | 'executive'
  | 'creative'
  | 'tech'
  | 'eco'
  | 'industrial'
  | 'elegant'
  | 'retro'
  | 'geometric'
  | 'magazine'
  | 'blueprint'
  | 'artistic'
  | 'startup'
  | 'legal'
  | 'cyber'
  | 'handwritten'
  | 'monochrome'
  // New Corporate Suite (20 New Templates)
  | 'corp-alpha'
  | 'corp-beta'
  | 'corp-gamma'
  | 'corp-delta'
  | 'corp-epsilon'
  | 'corp-zeta'
  | 'corp-eta'
  | 'corp-theta'
  | 'corp-iota'
  | 'corp-kappa'
  | 'pro-slate'
  | 'pro-obsidian'
  | 'pro-ivory'
  | 'pro-navy'
  | 'finance-prime'
  | 'finance-elite'
  | 'consult-apex'
  | 'consult-zenith'
  | 'agency-vogue'
  | 'agency-aura';